function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.52 1.38a1.46 1.46 0 00.48.46 2.74 2.74 0 00.64.32l.79.27q.5.16 1 .35a3.69 3.69 0 01.94.52 2.55 2.55 0 01.63.81v.11A3.13 3.13 0 001.38.54V.7a1.32 1.32 0 00.14.68zM4.7 4.71a1.67 1.67 0 00-.51-.51 3.43 3.43 0 00-.75-.36l-.9-.3a7.81 7.81 0 01-.94-.34 3.26 3.26 0 01-.83-.52A2.37 2.37 0 01.23 2a3.13 3.13 0 004.62 3.76 1.79 1.79 0 000-.3 1.38 1.38 0 00-.15-.75z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6.28 6.28"
  }, props), _ref);
};

export default SvgComponent;